export default __webpack_public_path__ + "static/hw_ff_ssd1306_schem-7db2cbee2817800523411308901a84d4.png";